__turbopack_context__.v({
  "icon": "Svg-module-scss-module__eM8JXW__icon",
});
